import * as utils from "./src/utils";

// imports (general functionality)
import "./src/third-party/object.assign.pollyfill"
import "./src/third-party/object.getownpropertydescriptors.pollyfill"
import "./src/appear"
import "./src/modal-draggability"
import "./src/form-validation"
import "./src/box-zooming"
import "./src/shortcuts"
import "./src/tooltips"
import "./src/popovers"
import "./src/css-skins"
// import "./src/treeview"
import "./src/wizard"
import "./src/submit-interception-modal"
import "./src/misc"

// global exports
export {
  // addClass,
  // removeClass,
  // toggleClass,
  toggleClassOnScroll,
  requestFullscreen,
  exitFullscreen,
  isFullscreen,
  htmlEntities,
  alterQueryString
} from "./src/utils"
export { AJAX } from "./src/ajax"
export { Modal } from "./src/modal"
export { makeExpandable } from "./src/dashboard-expandability"
export { ContextStorage } from "./src/context-storage"
export { rangeMirror } from "./src/range-mirror"
export * from "./src/infinite-scroll"
export * from "./src/css-tweakers"

// VOID namespace
import VOID from "./src/framework/framework"

VOID.utils.drag = utils.drag;
VOID.utils.ajax = utils.ajax;
VOID.utils.debounce = utils.debounce;
VOID.utils.throttle = utils.throttle;
VOID.utils.alterQueryString = utils.alterQueryString;
VOID.utils.formatNumber = utils.formatNumber;
VOID.utils.ajaxValidation = utils.ajaxValidation;
VOID.utils.createAJAXWarningHandler = utils.createAJAXWarningHandler;

import { randomColorCSS } from "./src/color-utils";
VOID.utils.color = {};
VOID.utils.color.random = randomColorCSS;

import {createMapsAPI} from "./src/google-maps"
VOID.Maps = createMapsAPI({
  language: "en",
  key: "AIzaSyDj102X0eUNBrpUoAh6zhEaCdXjt5mnnKw"
});

// import ClassDelayedToggler from "./src/class_delayed_toggler";
// VOID.utils.ClassDelayedToggler = ClassDelayedToggler;

import * as _ from "./src/framework/voidash";
VOID._ = _;

import Lang from "./src/localization";
VOID.Lang = Lang;

export { VOID }
